exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".c-display-system {\n  transform-origin: top left; }\n\n.c-display-system--screen-off {\n  visibility: hidden; }\n\n.c-display-system__fall-back {\n  background-size: auto;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10%;\n  font-size: 2.4em; }\n\n.c-display-system__default-image {\n  max-width: 80%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/displaySystem/displaySystem.scss
// module id = 649
// module chunks = 0